import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

import { changelogRemoveVehicleFeatures } from './utils/changelogRemoveVehicleFeatures'
import { changelogAddVehicleFeatures } from './utils/changelogAddVehicleFeatures'
import { changelogUpdateVehicleFeatures } from './utils/changelogUpdateVehicleFeatures'

export const createUpdateVehicleFeaturesFromChangelog = (
  markers: uui.domain.ui.map.markers.MapMarkers['vehicle'],
  mapStyles: uui.domain.ui.map.markers.MapStyles['vehicle'],
  selection: Set<string>,
  changelog: uui.domain.api.Changelog,
) => {
  // ATTENTION: Currently all changelog are applied as soon as they arrive, also when the map is not visible
  // `ignoreSelection` it will be used to avoid to apply any selection information to the map when applying cached updater functions.
  // after all cached updates will be applied a refresh selection action will be required
  return async (_ignoreSelection: boolean = false) => {
    const map = mapAtom.map
    const layer = findLayer(map, 'vehicle')

    // remove
    await changelogRemoveVehicleFeatures(layer, selection, changelog.remove.values())

    // add
    await changelogAddVehicleFeatures(layer, markers, mapStyles, selection, changelog.add.values())

    // update
    await changelogUpdateVehicleFeatures(
      layer,
      markers,
      mapStyles,
      selection,
      changelog.update.values(),
    )
  }
}
